'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'play';
var width = 512;
var height = 512;
var aliases = [9654];
var unicode = 'f04b';
var svgPathData = 'M64 16L64 496 496 256 64 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlay = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;